/* Das Ziffernblatt der Methodikseite.

   Es zeigt nicht irgendeine Zahl, sondern rechnet aus der echten Verteilung des
   Sortiments: Zu jedem Wert steht dort, wie viele Reifen ihn erreichen, und der
   Knopf darunter fuehrt genau in diese Auswahl.

   WARUM DIE VERTEILUNG IM MARKUP STEHT
   ------------------------------------
   Sie kaeme nur aus einer Aggregation ueber 25'000 Produkte, die Liquid nicht
   leisten kann und die als Abruf beim Seitenaufbau zu teuer waere. Sie liegt
   deshalb als Einstellung im Theme und wird nachgemessen — mit dem Datum
   daneben, damit sichtbar ist, wie alt sie ist. Der Groessen-Hub auf der
   Startseite hat gezeigt, wohin unbeschriftete Zahlen fuehren: Er wies 8'920
   Reifen aus, als 20'749 im Laden standen.
*/
(function () {
  'use strict';

  if (customElements.get('tire-index-skala')) return;

  customElements.define(
    'tire-index-skala',
    class TireIndexSkala extends HTMLElement {
      connectedCallback() {
        try {
          this.verteilung = JSON.parse(this.dataset.verteilung || '{}');
        } catch (e) {
          this.verteilung = {};
        }
        this.werte = Object.keys(this.verteilung).map(Number).sort(function (a, b) { return a - b; });
        if (this.werte.length < 2) return;

        this.min = this.werte[0];
        this.max = this.werte[this.werte.length - 1];
        this.wert = Math.min(this.max, Math.max(this.min, parseInt(this.dataset.start, 10) || this.max - 8));

        this.griff = this.querySelector('[data-rolle="griff"]');
        this.bogen = this.querySelector('[data-rolle="bogen"]');
        this.anzeige = this.querySelector('[data-rolle="wert"]');
        this.stufe = this.querySelector('[data-rolle="stufe"]');
        this.anzahl = this.querySelector('[data-rolle="anzahl"]');
        this.knopf = this.querySelector('[data-rolle="ziel"]');
        if (!this.griff || !this.bogen) return;

        this.stufen = [];
        var roh = (this.dataset.stufen || '').split('\n');
        for (var i = 0; i < roh.length; i++) {
          var t = roh[i].split('|');
          if (t.length >= 2 && t[0].trim()) {
            this.stufen.push({ ab: parseInt(t[0], 10), name: t[1].trim() });
          }
        }
        this.stufen.sort(function (a, b) { return b.ab - a.ab; });

        this.binden();
        this.zeichnen();
      }

      binden() {
        var self = this;
        var zieht = false;

        this.griff.addEventListener('pointerdown', function (e) {
          zieht = true;
          self.griff.setPointerCapture(e.pointerId);
          self.ausPunkt(e);
        });
        this.griff.addEventListener('pointermove', function (e) { if (zieht) self.ausPunkt(e); });
        this.griff.addEventListener('pointerup', function () { zieht = false; });
        this.griff.addEventListener('pointercancel', function () { zieht = false; });

        /* Tastatur: Das Ding ist ein Schieberegler und muss sich wie einer
           bedienen lassen. Ohne das waere die Seite fuer jeden unbrauchbar, der
           keine Maus benutzt. */
        this.griff.addEventListener('keydown', function (e) {
          var schritt = 0;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') schritt = 1;
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') schritt = -1;
          if (e.key === 'Home') { self.wert = self.min; schritt = 0; self.zeichnen(); e.preventDefault(); return; }
          if (e.key === 'End') { self.wert = self.max; schritt = 0; self.zeichnen(); e.preventDefault(); return; }
          if (!schritt) return;
          self.wert = Math.min(self.max, Math.max(self.min, self.wert + schritt));
          self.zeichnen();
          e.preventDefault();
        });
      }

      /* Der sichtbare Bogen laeuft ueber 270 Grad und beginnt unten links.
         Was darunter liegt, ist die Luecke — ein Zeigerinstrument ohne Luecke
         sieht aus wie ein Ladebalken. */
      ausPunkt(e) {
        var r = this.griff.getBoundingClientRect();
        var grad = Math.atan2(e.clientY - r.top - r.height / 2,
                              e.clientX - r.left - r.width / 2) * 180 / Math.PI - 135;
        if (grad < 0) grad += 360;
        if (grad > 270) return;
        this.wert = Math.round(this.min + grad / 270 * (this.max - this.min));
        this.zeichnen();
      }

      stufeVon(v) {
        for (var i = 0; i < this.stufen.length; i++) {
          if (v >= this.stufen[i].ab) return this.stufen[i].name;
        }
        return this.stufen.length ? this.stufen[this.stufen.length - 1].name : '';
      }

      zeichnen() {
        var anteil = (this.wert - this.min) / (this.max - this.min);
        var laenge = 2 * Math.PI * 86 * 0.75;
        this.bogen.style.strokeDasharray = laenge + ' 999';
        this.bogen.style.strokeDashoffset = laenge * (1 - anteil);
        this.setAttribute('data-band', this.band(this.wert));

        if (this.anzeige) this.anzeige.textContent = this.wert;
        if (this.stufe) this.stufe.textContent = this.stufeVon(this.wert);

        /* Die Tabelle liefert den Sofortwert — sie steht schon da, wenn die
           Seite aufgeht. Die richtige Zahl holt `anzahlLaden` gleich danach
           aus der Suche; bis sie da ist, ist ein Naeherungswert besser als ein
           Strich. */
        var ab = 0;
        for (var i = 0; i < this.werte.length; i++) {
          if (this.werte[i] >= this.wert) ab += this.verteilung[this.werte[i]];
        }
        if (this.anzahl) this.anzahl.textContent = ab.toLocaleString('de-CH').replace(/,/g, '’');

        /* „ab diesem Wert" heisst fuer Shopify: jeden einzelnen Wert darueber
           als eigenen Filterwert anhaengen. Einen Groesser-Gleich-Vergleich
           kennen die Facetten nicht.

           Gezaehlt wird ueber jede ganze Zahl bis 100, nicht nur ueber die
           Werte der Tabelle: In der Tabelle vom 14.08. fehlte etwa die 92
           ganz. Ein Reifen mit diesem Index waere weder mitgezaehlt noch
           mitverlinkt worden — unsichtbar, ohne dass es auffaellt. Werte ohne
           Treffer kosten nichts, Shopify laesst sie einfach fallen. */
        var adresse = this.dataset.ziel || '/search?type=product&q=tag:Reifen';
        var obergrenze = Math.max(this.max, 100);
        for (var w = this.wert; w <= obergrenze; w++) {
          adresse += '&filter.p.m.custom.vantiq_index=' + encodeURIComponent(w);
        }
        if (this.knopf) this.knopf.setAttribute('href', adresse);
        this.anzahlLaden(adresse);

        this.griff.setAttribute('aria-valuenow', this.wert);
        this.griff.setAttribute('aria-valuetext', this.wert + ' — ' + this.stufeVon(this.wert));
      }

      /* Die Zahl aus derselben Quelle holen, auf die der Knopf zeigt.

         Bis zum 16.08.2026 kam sie aus der Verteilungstabelle im
         Theme-Editor. Die war am 14.08. gemessen, der Katalog waechst
         taeglich — bei Index 93 stand 122 an der Skala und 151 in der
         verlinkten Liste. Wer beides sieht, glaubt keiner von beiden Zahlen
         mehr.

         Verzoegert und abbrechbar: Beim Ziehen aendert sich der Wert
         dutzendfach je Sekunde. Ohne Bremse waeren das dutzende Abfragen,
         von denen die letzte gilt — und ohne Abbruch koennte eine langsame
         fruehere Antwort die richtige spaetere ueberschreiben. */
      anzahlLaden(adresse) {
        if (!this.anzahl || typeof fetch !== 'function') return;
        var selbst = this;
        window.clearTimeout(this.zaehlUhr);
        this.zaehlUhr = window.setTimeout(function () {
          if (selbst.zaehlAbbruch) selbst.zaehlAbbruch.abort();
          var lauf = (selbst.zaehlLauf || 0) + 1;
          selbst.zaehlLauf = lauf;
          var einstellungen = {};
          if (typeof AbortController === 'function') {
            selbst.zaehlAbbruch = new AbortController();
            einstellungen.signal = selbst.zaehlAbbruch.signal;
          }
          fetch(adresse + '&view=anzahl', einstellungen)
            .then(function (antwort) { return antwort.ok ? antwort.json() : null; })
            .then(function (daten) {
              if (!daten || lauf !== selbst.zaehlLauf) return;
              var n = Number(daten.anzahl);
              if (!isFinite(n)) return;
              selbst.anzahl.textContent = n.toLocaleString('de-CH').replace(/,/g, '’');
            })
            .catch(function () {
              /* Netz weg oder Ansicht fehlt: Der Wert aus der Tabelle steht
                 schon da und bleibt stehen. Weniger genau, aber nicht kaputt. */
            });
        }, 250);
      }

      band(v) {
        for (var i = 0; i < this.stufen.length; i++) {
          if (v >= this.stufen[i].ab) return String(this.stufen[i].ab);
        }
        return String(this.min);
      }
    }
  );
})();
